/*
 * @Author: Ryan
 * @Date: 2026-01-19
 * @Description: SEO sections entry file for ai-product-avatar page
 */
import React from 'react';

import ComparisonSection from './ComparisonSection';
import CTASection from './CTASection';
import ExploreToolsSection from './ExploreToolsSection';
import FAQSection from './FAQSection';
import HeroSection from './HeroSection';
import HowToUseSection from './HowToUseSection';
import PowerfulFeaturesSection from './PowerfulFeaturesSection';
import TestimonialsSection from './TestimonialsSection';
import UseCasesSection from './UseCasesSection';
import WhyChooseSection from './WhyChooseSection';

const SEOSections: React.FC = () => {
  return (
    <>
      <HeroSection />
      <HowToUseSection />
      <PowerfulFeaturesSection />
      <UseCasesSection />
      <WhyChooseSection />
      <ComparisonSection />
      <TestimonialsSection />
      <ExploreToolsSection />
      <FAQSection />
      <CTASection />
    </>
  );
};

export default SEOSections;

// Also export individual components for on-demand imports
export {
  ComparisonSection,
  CTASection,
  ExploreToolsSection,
  FAQSection,
  HeroSection,
  HowToUseSection,
  PowerfulFeaturesSection,
  TestimonialsSection,
  UseCasesSection,
  WhyChooseSection,
};
export { default as StartButton } from './StartButton';
